import { defineStore } from "pinia";
import axios from "axios";
import { useUserStore } from './UserStore'

export const useOthStore = defineStore('OthStore', {
    state: () => {
        return {
            search_cat: [],
            active_search: [],
            demo: false,
            products: {
                config: {
                    page_steps: [24,48,96],
                    //page_steps: [10,50,100],
                    page: 1,
                    on_load: false,
                    view: 'table', // table or cells
                    default_tab : 'type_tyres',
                    default_fill : false,
                },
                s_keys : {
                    'start' : 0,
                    'length' : 24,//TODO: это надо вычислять на основе page_steps
                    'order_by': 'cae',
                    'order_dir': 'desc',
                },
                s_results : {},
            },
            is_oth: 0,
            modal:{
                title: 'Заголовок',
                is_loading: false,
                product : {},
            },
        }
    },
    actions:{
        clear_search_keys(){
            this.products.s_keys = {};
            this.products.s_keys.start = 0;
            this.products.s_keys.length = this.products.config.page_steps[0];
            this.products.s_results = {};
        },
        switch_item_full_view(index){
            if(this.products.s_results.items[index].expand === true)
            {
                this.products.s_results.items[index].expand = false
            }
            else
            {
                this.products.s_results.items[index].expand = true;
            }
        },
        set_storage_active(key){
            // TODO: проверить есть ли массив, скорее всего он будет другим, а так же проверить на наличее нужных данных

            if(key === 33)
            {
                let bool_var = true;
                if(this.active_search.childs.search_ui.childs.storages_cat.items[33].active)
                {
                    bool_var = false;
                }
                for (const index in this.active_search.childs.search_ui.childs.storages_cat.items) {
                    this.active_search.childs.search_ui.childs.storages_cat.items[index].active = bool_var;
                }
            }
            else
            {
                for (const index in this.active_search.childs.search_ui.childs.storages_cat.items) {
                    if(Number(index) === Number(key))
                    {
                        //console.log(this.active_search.childs.search_ui.childs.storages_cat.items[index].active);
                        if(this.active_search.childs.search_ui.childs.storages_cat.items[index].active)
                        {
                            this.active_search.childs.search_ui.childs.storages_cat.items[index].active = false;
                        }
                        else
                        {
                            this.active_search.childs.search_ui.childs.storages_cat.items[index].active = true;
                        }
                    }
                }
            }

        },
        async fill_products(is_oth = true){

            let api_metod_url = 'search';
            if(is_oth)
            {
                api_metod_url = 'search_oth';
            }

            this.products.config.on_load = true;

            const params = new URLSearchParams();
            //params.append('delivery_zones[Наличие]', 'Наличие');
            //params.append('delivery_zones[1-5+дней]', '1-5+дней');
            //params.append('width', '155');
            //params.append('type', 'type_tyres');
            params.append('storehouse_all', '1');
            //params.append('start', '0');
            //params.append('length', '24');
            //params.append('spikes', '0');
            params.append('protect', '0');
            params.append('order[0][column]', '1');
            params.append('order[0][dir]', 'desc');
            params.append('draw', '1');



            // Проверяем и устанавливаем - оновной тип товара
            if(typeof(this.active_search.key) !== "undefined" && this.active_search.key !== null) {
                params.append('type', this.active_search.key);
                //params.append('type', 'type_accessory');
            }


            // TOOLS
            //params.append('sub_type', 'tools');
            //params.append('tools_sub_category', 'tools_'+this.products.s_keys.tools_sub_category[0]);

            // OTH
            // params.append(
            //     'storehouse_all',
            //     '1'
            // );

            // Добавление полей "Склады", либо их удаление если были назначены ранее
            for (const index in this.active_search.childs.search_ui.childs.storages_cat.items) {
                if(this.active_search.childs.search_ui.childs.storages_cat.items[index].active && this.active_search.childs.search_ui.childs.storages_cat.items[index].othstore !== true)
                {
                    params.append(
                        'delivery_zones['+this.active_search.childs.search_ui.childs.storages_cat.items[index].properties.js_value.value+']',
                        this.active_search.childs.search_ui.childs.storages_cat.items[index].properties.js_value.value
                    );
                }
                else if (this.active_search.childs.search_ui.childs.storages_cat.items[index].active && this.active_search.childs.search_ui.childs.storages_cat.items[index].othstore === true)
                {
                    params.append(
                        'oth_store['+index+']',
                        this.active_search.childs.search_ui.childs.storages_cat.items[index].properties.js_value.value
                    );
                }
                else
                {
                    delete params['delivery_zones['+this.active_search.childs.search_ui.childs.storages_cat.items[index].properties.js_value.value+']'];
                }
            }

            // Проверим на пустой length - TODO: удалить когда будет настроена невозможность очистить select
            if(typeof(this.products.s_keys.length) === "undefined" || this.products.s_keys.length === null) {
                this.products.s_keys.length = this.products.config.page_steps[0];
            }


            // Удаляем null и ранее установленные
            for (const index in this.products.s_keys) {
                // this.products.s_keys[key]
                console.log(index,this.products.s_keys[index]);

                if(index in params)
                {
                    // TODO: проверить и протестировать удаление...
                    delete params[index]
                }
                //
                if(this.products.s_keys[index] === null || this.products.s_keys[index] === undefined)
                {
                    //delete this.products.s_keys[index]
                }
                else
                {
                    // Провоеряем пришел ли массив
                    //console.log(index,typeof (this.products.s_keys[index]));
                    if(typeof (this.products.s_keys[index])==='object')
                    {
                        let counter = 0;
                        for (const key in this.products.s_keys[index]) {
                            params.append(index+'['+counter+']', this.products.s_keys[index][key]);
                            counter++;
                        }
                        // console.log('OBJECT:',index);
                    }
                    else
                    {
                        params.append(index, this.products.s_keys[index]);
                    }
                }
            }

            const userStore = useUserStore()
            // TODO: Перенести в более логичное место
            if(userStore.user.demo_mode === 1)
            {
                this.demo = true;
            }
            let reqResult = (await axios.post('/api/'+api_metod_url, params,{
                withCredentials: true,
            })).data;

            if(typeof(reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                console.log('Error Get Products Data');
            }
            else
            {

                for (let i = 0; i < reqResult.items.length; i++) {
                    // Устанавливаем общую цену, устанавливаем сколько добавлено в корзину
                    let minPrice = 0;
                    let in_basket = false;
                    for (let w = 0; w < reqResult.items[i].price.length; w++) {
                        if( Number(reqResult.items[i].price[w].price_vip) < minPrice || minPrice === 0 )
                        {
                            minPrice = Number(reqResult.items[i].price[w].price_vip);
                        }
                        reqResult.items[i].price[w].in_basket = 0;
                        reqResult.items[i].price[w].filled = false// Установим прочие переменнны для UI
                        // Далее выясним сколько уже добавлено в корзину для данного товара
                        // TODO: не верно для не 1 склада!
                        for (const index in userStore.user.web_basket.items) {
                            if(userStore.user.web_basket.items[index].id === reqResult.items[i].uuid)
                            {
                                reqResult.items[i].price[w].in_basket = userStore.user.web_basket.items[index].count;
                                reqResult.items[i].price[w].filled = true;
                                in_basket = true;
                            }
                        }

                        reqResult.items[i].price[w].at_load = false; // Установим прочие переменнны для UI

                    }
                    // TODO: возможно не верное назначение цены
                    reqResult.items[i].min_price = minPrice;
                    reqResult.items[i].expand = false; // Установим прочие переменнны для UI
                    reqResult.items[i].in_basket = in_basket;
                }

                // TODO: Проверить поступившие данные!
                reqResult.start = Number(reqResult.start);
                reqResult.length = Number(reqResult.length);
                reqResult.count = Number(reqResult.count);
                this.products.s_keys.start = reqResult.start;
                this.products.s_keys.length = reqResult.length;
                this.products.s_keys.count = reqResult.count;

                if(reqResult.start > 0)
                {
                    reqResult.page = Math.floor((reqResult.start - 1)/reqResult.length);
                }
                else
                {
                    reqResult.page = 1;
                }

                reqResult.pages = Math.floor(reqResult.count/reqResult.length);


                this.products.s_results = reqResult;

            }
            this.products.config.on_load = false;
        },
        set_products_in_basket(){
            console.log('Обновление данных товаров зависящих от корзины');
            const userStore = useUserStore();
            // Идем по загруженным продуктам - определяя и передавая данные смежные с корзиной
            for (const index in this.products.s_results.items) {
                let set_count = 0;
                // Идем по всем товарам в корзине
                for (const index_b_item in userStore.user.web_basket.items) {
                    // Если uuid - совпадает с товаром в корзине - переходим к передаче кол-ва TODO: переделать т.к. ошибка с учетом разных складов
                    if(this.products.s_results.items[index].uuid === userStore.user.web_basket.items[index_b_item].uuid)
                    {
                        set_count = userStore.user.web_basket.items[index_b_item].count;
                    }
                }
                // Идем по всем "складам" позиции и назначаем им количество добавленное в корзину TODO: переделать т.к. ошибка
                for (const index_price in this.products.s_results.items[index].price) {
                    // Передаем кол-во указанное в корзине
                    this.products.s_results.items[index].price[index_price].in_basket = set_count;
                }
            }
        },
        async add_to_basket(index,index_store,in_basket){
            console.log('Добавление в корзину - '+this.products.s_results.items[index].name);
            const userStore = useUserStore()
            if(typeof(this.products.s_results.items[index].price[index_store].stock) == "undefined")
            {
                console.log('Ошибка - не найден склад');
                return false; // TODO: ответ в неверном формате для "response_process"
            }
            // Разбираемся с макс. количеством
            let max_count = 999;
            let stock = Number(this.products.s_results.items[index].price[index_store].stock);
            if(stock < 40)
            {
                max_count = stock;
            }
            if(max_count < in_basket && in_basket !== this.products.s_results.items[index].price[index_store].in_basket)
            {
                console.log('Добавлено макс. на складе кол-во - изменено добавляемое на максимальное');
                in_basket = max_count;
                this.products.s_results.items[index].price[index_store].in_basket = max_count;
            }
            // TODO: не работает т.к. условие выше!
            else if (max_count < in_basket && in_basket >= this.products.s_results.items[index].price[index_store].in_basket)
            {
                //console.log('Debug !!!!:', 2);
                // Устанавливаем макс. в результатах поисковой выдачи и
                this.products.s_results.items[index].price[index_store].in_basket = max_count;
                //Выходим - ничего не изменяя, указав "в корзине" - максимальное для данного склада
                if(in_basket >= this.products.s_results.items[index].price[index_store].in_basket)
                {
                    // this.products.s_results.items[index].price[index_store].in_basket = stock;
                    this.products.s_results.items[index].price[index_store].in_basket = max_count;
                    return {
                        success: true,
                        type: 'error',
                        message: 'Установлено максимальное количество'
                    };
                }
            }
            // Удаляем - выставляя 0
            if(in_basket <= 0)
            {
                console.log('Меньше нуля или 0 - индицируем удаление');
                in_basket = 0;
            }

            //console.log('!!! Debug:',in_basket);


            console.log('Добавляем');
            var arr = {
                id: this.products.s_results.items[index].uuid,
                uuid: this.products.s_results.items[index].uuid,
                name: this.products.s_results.items[index].name,
                id_price: this.products.s_results.items[index].price[index_store].id_price,
                id_storehouse: this.products.s_results.items[index].price[index_store].id_storehouse,
                in_stock: this.products.s_results.items[index].price[index_store].in_stock,
                count: Number(in_basket),
                price: this.products.s_results.items[index].price[index_store].price_vip,
                index_s_results: index,
                index_store: index_store,
                is_update: false,
            };
            this.products.s_results.items[index].price[index_store].in_basket = in_basket;
            this.products.s_results.items[index].price[index_store].at_load = true;


            let reqResult = await userStore.write_basket_oth(arr);

            // TODO: рефакторинг проброса этих данных
            if(typeof(reqResult.index_s_results) !== "undefined" && reqResult.index_s_results !== null && typeof(reqResult.index_store) !== "undefined" && reqResult.index_store !== null) {
                if(Number(in_basket) > 0)
                {
                    this.products.s_results.items[index].price[index_store].filled = true;
                    this.products.s_results.items[index].in_basket = true;
                }
            }
            else
            {
                this.products.s_results.items[index].price[index_store].filled = false;
                this.products.s_results.items[index].in_basket = false;
            }
            console.log('Debug OUTSIDE:',reqResult);
            this.products.s_results.items[index].price[index_store].at_load = false;



            return reqResult;
        },
        async fill_search_cat(){
            const userStore = useUserStore()
            let reqResult = (await axios.get('/api/GetDictionaryByCategory/goods_types', {
                withCredentials: true,
            })).data;

            if(typeof(reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                console.log('Error Get search_cat Data');
            }

            this.search_cat = reqResult;

            // TODO: Перенести в более логичное место
            if(userStore.user.demo_mode === 1)
            {
                this.demo = true;
            }

            this.fill_active_search(this.products.config.default_tab,true);
        },
        fill_active_search(select_key, is_oth = false){
            //console.log('Debug fill_active_search:',select_key,is_oth);
            // Очищаем заданные ключи поиска
            this.clear_search_keys();
            const userStore = useUserStore()
            // TODO: Перенести в более логичное место
            if(userStore.user.demo_mode === 1)
            {
                this.demo = true;
            }
            // Идем по "справочнику" типов товаров и при совпадении ключа - наполняем "активный поиск"
            for (var key in this.search_cat.results.search_categories.childs.goods_types.childs) {
                if(key === select_key)
                {
                    this.active_search = this.search_cat.results.search_categories.childs.goods_types.childs[key];
                    //ДЛЯ ОТХ - дополним склады складоми ОТХ
                    if(typeof (userStore.user.oth_stocks) === 'object' && Object.keys(userStore.user.oth_stocks).length > 0 && is_oth === true)
                    {
                        for (const keyOth in userStore.user.oth_stocks) {

                            //console.log(userStore.user.oth_stocks[keyOth].oth_stock_id,userStore.user.oth_stocks[keyOth].oth_stock_name)
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth] = {}
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties = {}
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.js_value = {}
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.storage_name = {}
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.css_class_ico = {}
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.name_form = {}

                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].id = keyOth;
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.js_value.value = userStore.user.oth_stocks[keyOth].oth_stock_id;
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.storage_name.value = userStore.user.oth_stocks[keyOth].oth_stock_name;
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.css_class_ico.value = 'ico_delivery';
                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].properties.name_form.value = userStore.user.oth_stocks[keyOth].oth_stock_id; // TODO: убидиться что этот параметр name_form - вообще нужен (см. шаблон)

                            this.active_search.childs.search_ui.childs.storages_cat.items[keyOth].othstore = true;
                        }
                    }

                    // Идем по всем "складам"
                    for (const index in this.active_search.childs.search_ui.childs.storages_cat.items) {
                        //console.log('Debug!!!:',this.active_search.childs.search_ui.childs.storages_cat.items[index]);
                        // Автовыбор всех складов
                        this.active_search.childs.search_ui.childs.storages_cat.items[index].active = true;
                        // ЭТО не отх склад
                        if(typeof (this.active_search.childs.search_ui.childs.storages_cat.items[index].othstore) === 'undefined')
                        {
                            this.active_search.childs.search_ui.childs.storages_cat.items[index].othstore = false;
                        }
                        //console.log('Debug!!!2:',this.active_search.childs.search_ui.childs.storages_cat.items[index].othstore);
                        // Если это запрос ОТХ - удаляем все склады, кроме ОТХ складов
                        if(is_oth && this.active_search.childs.search_ui.childs.storages_cat.items[index].othstore !== true)
                        {
                            delete this.active_search.childs.search_ui.childs.storages_cat.items[index];
                        }
                    }
                }
            }
            // Если установлен флаг - наполняем данными - автоматически отправляем форму поиска
            if(this.products.config.default_fill === true)
            {
                this.fill_products(is_oth);
            }
        },
        async fill_product_data(product_id){
            this.modal.is_loading = true;
            const userStore = useUserStore();
            let reqResult = (await axios.get('/api/product_info/'+product_id, {
                withCredentials: true,
            })).data;

            if(typeof(reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                console.log('Error Get Product Data');
            }
            else
            {
                this.modal.product = reqResult;
            }
            this.modal.is_loading = false;
        },

    }
})